<script lang="ts">
export default {
  name: 'AccountWarning',
}
</script>

<script setup lang="ts">
import { AccountSummary, accountSummaryWarnings } from '@/types/AccountSummary';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { TriangleAlert } from '@lucide/vue';
import AppModal from '@/components/v2/AppModal.vue';

const props = defineProps<{
  account: AccountSummary;
}>();

const router = useRouter();
const show = ref(false);

const warnings = computed(() => {
  return accountSummaryWarnings(props.account);
});

function closeModal() {
  show.value = false;
}

function goToEdit() {
  show.value = false;
  router.push(`/account/${props.account.accountID}/edit`);
}
</script>

<template>
  <template v-if="warnings.length > 0">
    <triangle-alert
      class="h-4 w-4 cursor-pointer text-warning"
      @click="show = true" />
    <AppModal
      :show="show"
      size="sm"
      cancel-button-label="Cancel"
      action-button-label="Edit Account"
      :handle-cancel="closeModal"
      :handle-action="goToEdit">
      <template #title>
        <h1>{{ account.accountName }} Warnings</h1>
      </template>
      <template #content>
        <p class="pb-3 text-sm">This account has the following warnings:</p>
        <ul class="list-disc px-8 text-sm">
          <li v-for="warning in warnings" :key="warning">
            {{ warning }}
          </li>
        </ul>
      </template>
    </AppModal>
  </template>
</template>
